module.exports = __webpack_public_path__ + "static/img/biasfx2-rack-multicomp-2.51bac51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/biasfx2-rack-multicomp-2.jpg
// module id = c/od
// module chunks = 12